import { useEffect } from "react";
import { useSetGlobalError } from "../atoms/useGlobalError";

const isChunkLoadError = (message: string): boolean => {
  return (
    message.includes("dynamically imported") ||
    message.includes("failed to fetch") ||
    message.includes("importing a module script failed") ||
    message.includes("loading chunk") ||
    message.includes("chunkloaderror") ||
    message.includes("load failed")
  );
};

const useChunkErrorHook = () => {
  const setGlobalError = useSetGlobalError();

  useEffect(() => {
    const handleChunkError = (event: Event) => {
      event.preventDefault();
      const e = event as CustomEvent<{ payload?: Error }>;
      const payload = e.detail?.payload ?? e.detail ?? e["payload"];
      const message =
        payload instanceof Error ? payload.message : String(payload ?? "");

      if (isChunkLoadError(message)) {
        setGlobalError(new Error(message));
      }
    };
    window.addEventListener("vite:preloadError", handleChunkError);
    return () => {
      window.removeEventListener("vite:preloadError", handleChunkError);
    };
  }, [setGlobalError]);
};

export default useChunkErrorHook;
